<details class="govuk-details govuk-!-margin-bottom-{{ bottomSpacing }}">
  <summary class="govuk-details__summary">
    <span class="govuk-details__summary-text">{{ summary }}</span>
  </summary>
  <div class="govuk-details__text">
    <ng-content></ng-content>
  </div>
</details>
